import { Loader } from '../loaders/Loader';

export default function LoaderWrapper({ children, isLoading, className }: any) {
    return (
        <div className={'loader-wrapper-div' + (className ? ` ${className}` : '')}>
            {isLoading ? <Loader /> : <>{children}</>}
        </div>
    )
}
